(function () {
  'use strict';
  function formatHour(hour24) {
    var h = ((hour24 % 12) + 12) % 12 || 12;
    var suffix = hour24 >= 12 ? 'PM' : 'AM';
    return h + ':00 ' + suffix;
  }
  function updateDeliveryEstimate(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoff)) return;
    var textEl = el.querySelector('[data-tb-delivery-text]');
    if (!textEl) return;
    var now = new Date();
    var currentHour = now.getHours();
    if (currentHour < cutoff) {
      textEl.textContent = 'Order within the next ' + (cutoff - currentHour) + ' hour' + (cutoff - currentHour === 1 ? '' : 's') + ' (by ' + formatHour(cutoff) + ') for dispatch today.';
    } else {
      textEl.textContent = 'Order now for dispatch on the next business day.';
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tb-delivery]').forEach(updateDeliveryEstimate);
  });
})();
